import { FC, ReactNode } from 'react';

import { cn } from '@eluve/components';

const gapStyles: Record<number, string> = {
  1: 'gap-1',
  2: 'gap-2',
  3: 'gap-3',
  4: 'gap-4',
  6: 'gap-6',
  8: 'gap-8',
};

const paddingStyles: Record<number, string> = {
  2: 'p-2',
  3: 'p-3',
  4: 'p-4',
  6: 'p-6',
  8: 'p-8',
};

const alignStyles = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
} as const;

const justifyStyles = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
} as const;

const textAlignStyles = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
} as const;

export interface BoxRendererProps {
  direction?: 'row' | 'column';
  gap?: number;
  align?: 'start' | 'center' | 'end' | 'stretch';
  justify?: 'start' | 'center' | 'end' | 'between';
  padding?: number;
  fullWidth?: boolean;
  textAlign?: 'left' | 'center' | 'right';
  children?: ReactNode;
}

export const BoxRenderer: FC<BoxRendererProps> = ({
  direction,
  gap,
  align,
  justify,
  padding,
  fullWidth,
  textAlign,
  children,
}) => (
  <div
    className={cn(
      direction || gap || align || justify ? 'flex' : undefined,
      direction === 'row'
        ? 'flex-row'
        : direction === 'column'
          ? 'flex-col'
          : undefined,
      gap != null ? gapStyles[gap] : undefined,
      align ? alignStyles[align] : undefined,
      justify ? justifyStyles[justify] : undefined,
      padding != null ? paddingStyles[padding] : undefined,
      fullWidth && 'w-full',
      textAlign ? textAlignStyles[textAlign] : undefined,
    )}
  >
    {children}
  </div>
);
